export function ShopInfo (dict) {
    if (!dict) return;
    
    this.province = dict.Province || dict.province || '';
    this.shopId = dict.ShopId || dict.shopId || '';
    this.shopName = dict.ShopName || dict.shopName || '';
}